import classname from 'classnames'
import React from 'react'

const Tabs = ({ children }) => {
	return (
		<div className="tabs">
			<div className="tabs__cols">
				{React.Children.map(children, child => (
					<div className={`tabs__col`}>
						{child}
					</div>
				))}
			</div>
		</div>
	)
}

const Tab = ({ label, active, prefix, isVisible = true, onClick, counter, id = "" }) => {

	/* Removing tab component visibility from the screen */
	if (!isVisible) {
		return null;
	}

	const tabClass = classname({
		'tabs__item': true,
		'tabs__item--active': active,
	})

	const tabPrefixClass = classname({
		'tab__prefix': true,
		'tab__prefix--active': active,
	})

	return (
		<div className={tabClass} onClick={onClick}>
			<div className='tab__wrapper'>
				{prefix && <span className={tabPrefixClass}>{prefix}</span>}
				<span id={id}>{label}</span>
				{counter && <span className='tab_counter'>{counter}</span>}
			</div>
		</div>
	)
}

export default Tabs
export { Tab }
